import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

// Without a catch-all route, an unknown URL rendered a blank white page with no
// error and no way back.
export default function NotFound() {
  const { user } = useAuth();
  const home = user ? `/${user.role}` : "/login";
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="text-center max-w-md">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center">
          <Compass className="h-7 w-7 text-blue-900" />
        </div>
        <h1 className="mt-5 text-2xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
          We can’t find that page
        </h1>
        <p className="mt-2 text-slate-500">
          The link may be out of date, or the page may have moved.
        </p>
        <Link to={home} className="inline-block mt-6">
          <Button className="h-12 px-6 bg-blue-900 hover:bg-blue-800">
            {user ? "Back to my dashboard" : "Go to sign in"}
          </Button>
        </Link>
      </div>
    </div>
  );
}
